import { Material } from "./material.model";

export class TraditionalTrail {
  constructor(
    public id: string = "",
    public name: string = "",
    public description: string = "",
    public materials: Material[] = [],
    public predecessorId: string = "",
    public done: boolean = false,
    public existQuiz?: boolean
  ) {}
}
